import * as tp from 'io-ts-promise';
import axios from 'axios';
import { AxiosResponse } from 'axios';

import Data from '../../Data';
import Endpoints from '../endpoints';
import { getDataFromAxios } from '../common';
import { DetailOrganisationResponse } from './response_models';

export const loadOrganisation = (identifier: string): Promise<AxiosResponse<DetailOrganisationResponse>> =>
  axios.get(Endpoints.organisations.DETAIL(identifier), Data.async.authorisationHeaders());

export default async (identifier: string) =>
  await loadOrganisation(identifier).then(getDataFromAxios.get).then(tp.decode(DetailOrganisationResponse));
